import axios from "axios";
import { APIOverrides } from "../../ApiOverrides";
import type { AthleteProps, EventProps, LeagueProps, MatchProps, OrderProps, PlayerFollowerProps, PlayerPodcastEpisodeProps, PlayerPodcastProps, PodcastEpisodesProps, PodcastProps, PostReactionProps, PublicPlayerProps, TextTagProps, TeamProps, TournamentProps, GroupProps, GroupMessageProps, GroupPlayerProps, MyPlayerProps, URLMetadataProps, PostProps, ArticleProps, PostCommentProps } from "../../types";
import Colors from "../../constants/colors";
import moment from "moment-mini";

let SOCIAL_SVC_API = '';
let EVENT_SVC_API = '';
let MK_SVC_API = '';
let AUTH_SVC_API = '';
export { SocialComponentApi, SocialOrderHelpers, SocialPodcastHelpers, SocialComponentHelpers }

const SocialComponentApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        MK_SVC_API = endpoints['MK_SVC_API'] as string;
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;

    },
    getLeagues: async():Promise<LeagueProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues`);
            return resp.data.leagues   
        } catch (e) {
            return []
        }
    },
    getPostComments: async(post_id:string, offset:number):Promise<PostCommentProps[]> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v1/posts/comments/post/${post_id}?post_type=memo&offset=${offset}`);
            return resp.data.post_comments
        } catch (e) {
            console.log(e)
            return []
        }
    },
    createComment: async(post_comment:PostCommentProps):Promise<undefined | PostCommentProps> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/posts/comment/create`, { post_comment });
            return resp.data.post_comment
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    getPlayersByIds: async(player_ids:string[]):Promise<PublicPlayerProps[]> => {
        try {
            if(player_ids.length == 0){ return [] }
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/bulk/get`, { player_ids });
            return resp.data.players
        } catch (e) {
            return []
        }
    },
    reverseOrder: async(order:OrderProps):Promise<OrderProps | undefined> => {
        try {
            const resp = await axios.post(`${MK_SVC_API}/v1/orders/order/reverse`, { order })
            return resp.data.order
        } catch (e) {
            return undefined
        }
    },
    getBulkPlayerfollowers: async(player_ids:string[]) => {
        const resp = await axios.post(`${SOCIAL_SVC_API}/v1/followers/bulk/get`, { player_ids })
        return resp.data.player_followers
    },
    savePlayerFollower: async(player_follower:PlayerFollowerProps):Promise<PlayerFollowerProps> => {
        const resp = await axios.post(`${SOCIAL_SVC_API}/v1/followers/player/create`, { player_follower })
        return resp.data.player_follower
    },
    getPostById: async(memo_post_id:string, post_type:string):Promise<PostProps | undefined> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v1/posts/post/${memo_post_id}?post_type=${post_type}`);
            return resp.data.post
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
    getMyAction:async():Promise<OrderProps[]> => {
        try {
            const resp = await axios.get(`${MK_SVC_API}/v1/orders/action/me`);
            return resp.data.orders
        } catch (e) {
            console.log(e);
            return []
        }
    },
    getBulkOrders: async(order_ids:string[]):Promise<OrderProps[]> => {
        try {
            if(order_ids.length == 0){ return [] }
            const resp = await axios.post(`${MK_SVC_API}/v1/orders/bulk/get`, { order_ids });
            return resp.data.orders
        } catch (e) {
            console.log('error ggetting orders')
            return []
        }
    },
    createPost: async(post:PostProps):Promise<PostProps | undefined> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/posts/post/create`, { post });
            return resp.data.post
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    updatePost: async(post:PostProps):Promise<PostProps | undefined> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/posts/post/update`, { post });
            return resp.data.post
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    getEventsByEventIds: async(event_ids:string[]):Promise<EventProps[]> => {
        if(event_ids.length == 0){ return [] }
        try {
            const resp = await axios.post(`${EVENT_SVC_API}/v1/events/bulk/get`, { attribute:'event_id', values: event_ids })
            return resp.data.events
        } catch (e) {
            return []
        }
    },
    searchPlayerByUsername: async(username:string):Promise<PublicPlayerProps|undefined> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/player/search/username`, { username })
            return resp.data.player
        } catch (e) {
            console.log('there was an error')
            console.log(e)
            return undefined
        }
    },
    searchPlayersByValue: async(search_value:string, offset:number):Promise<PublicPlayerProps[]> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/player/search/value`, { search_value, offset })
            return resp.data.players
        } catch (e) {
            return []
        }
    },
    getMyDetails: async():Promise<MyPlayerProps|undefined> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/players/player/me`)
            return resp.data.player
        } catch (e) {
            return undefined
        }

    },
    getBulkArticles: async(article_ids:string[]):Promise<ArticleProps[]> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/articles/bulk/get`, { attribute: 'article_id', values:article_ids })
            return resp.data.articles
        } catch (error) {
            return []
        }
    },
    getMatchesByMatchIds: async(match_ids:string[]):Promise<MatchProps[]> => {
        if(match_ids.length == 0){ return [] }
        try {
            const resp = await axios.post(`${EVENT_SVC_API}/v1/matches/bulk/get`, { attribute: 'match_id', values: match_ids })
            return resp.data.matches
        } catch (e) {
            return []
        }
    },
    getAthletesByIds : async(athlete_ids:string[]):Promise<AthleteProps[]> => {
        if(athlete_ids.length == 0){ return [] }
        try {
            const resp = await axios.post(`${EVENT_SVC_API}/v1/athletes/bulk/get`, { attribute: 'athlete_id', values: athlete_ids })
            return resp.data.athletes
        } catch (e) {
            return []
        }
    },
    getTournamentsByTournamentIds: async(tournament_ids:string[]):Promise<TournamentProps[]> => {
        if(tournament_ids.length == 0){ return [] }
        try {
            const resp = await axios.post(`${EVENT_SVC_API}/v1/tournaments/bulk/get`, { attribute: 'event_id', values: tournament_ids })
            return resp.data.tournaments
        } catch (e) {
            return []
        }
    },
    getTeamsByIds: async(team_ids:string[]) => {
        if(team_ids.length == 0){ return [] }
        try {
            const resp = await axios.post(`${EVENT_SVC_API}/v1/teams/bulk/get`, { attribute:'team_id', values: team_ids })
            return resp.data.teams
        } catch (e) {
            return []
        }
    },
    createPostReaction: async(post_reaction:PostReactionProps):Promise<PostReactionProps|undefined> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/posts/reaction/create`, { post_reaction });
            return resp.data.post_reaction
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    getUrlMetadata: async(url:string):Promise<URLMetadataProps | undefined> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/posts/link/preview`, { url });
            return resp.data.link_preview
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    updatePostReaction : async(post_reaction:PostReactionProps):Promise<PostReactionProps|undefined> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/posts/reaction/update`, { post_reaction })
            return resp.data.post_reaction
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
    getPodcastById: async(podcast_id:string):Promise<PodcastProps | undefined> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v1/podcasts/podcast/${podcast_id}`);
            return resp.data.podcast
        } catch (e) {
            return undefined
        }
    },
    getPodcastEpisodeById: async(podcast_episode_id:string):Promise<PodcastEpisodesProps | undefined> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v1/podcasts/episodes/episode/${podcast_episode_id}`);
            return resp.data.podcast_episode
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
    getPlayerPodcastEpisode: async(podcast_episode_id:string):Promise<undefined | { player_podcast?:PlayerPodcastProps, player_podcast_episode?:PlayerPodcastEpisodeProps }> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v1/podcasts/episode/player/${podcast_episode_id}`);
            return resp.data
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
    startPodcastEpisode: async(podcast_episode_id:string):Promise<undefined | { player_podcast:PlayerPodcastProps, player_podcast_episode:PlayerPodcastEpisodeProps }> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/podcasts/episode/start`, { podcast_episode_id });
            return resp.data
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
    pausePodcastEpisode:async(podcast_episode_id:string, pause_timestamp:number):Promise<undefined | PlayerPodcastEpisodeProps> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/podcasts/episode/pause`, { podcast_episode_id, pause_timestamp });
            return resp.data.player_podcast_episode
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
    getChat: async(player_id:string):Promise<{ group:GroupProps, group_messages:GroupMessageProps[], group_players:GroupPlayerProps[] }|undefined> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v1/groups/chat/direct/${player_id}`)
            return resp.data
        } catch (e) {
            return undefined
        }
    },
    getGroupById: async(group_id:string):Promise<{ group:GroupProps, group_messages:GroupMessageProps[], group_players:GroupPlayerProps[] }|undefined> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v1/groups/group/${group_id}`);
            return resp.data
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    sendChat: async(group_message:GroupMessageProps) => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/groups/message/create`, { group_message });
            return resp.data.group_message
        } catch (e) {
            console.log(e)
            return undefined
        }
    },
}


const SocialOrderHelpers = {
    getIconColor: (order:OrderProps) => {
        switch(order.status){
            case 'approved':
                return Colors.brand.electric
            case 'closed':
                return Colors.brand.midnight
            case 'cancelled':
                return Colors.highlights.highlight200
            default:
                return Colors.shades.black
        }
    },
    getResultDetails: (order:OrderProps) => {
        if(order.resolution_status == 'inprogress'){ return { result_label: '', color:Colors.brand.midnight } }
        if(order.resolution_status == 'closed' && !order.positions[0]){ return { result_label: 'CANCELLED', color:Colors.brand.slate } }
        let position = order.positions[0]
        if(!position || position.status == 'inprogress'){ return { result_label: '', color:Colors.brand.midnight } }
        switch(position.result_ind){
            case 'win': return { result_label: 'WIN', color:Colors.utility.success }
            case 'lose': return { result_label: 'LOSE', color:Colors.utility.error }
            case 'draw': return { result_label: 'DRAW', color:Colors.brand.midnight }
            default: return { result_label: '', color:Colors.brand.midnight }
        }
    },
    calcPotentialWinnings :(odds:number, amt:number) => {
        let potential_winnings;
        if (odds > 0) {
            var earningsMultiplyer = (odds/100) + 1;
            potential_winnings = Math.round(earningsMultiplyer * amt * 100) / 100;
        } else {
            var earningsMultiplyer = (100/(Math.abs(odds))) + 1;
            potential_winnings = Math.round(earningsMultiplyer * amt * 100) / 100;
        }
        return potential_winnings
    },
    getIdsFromOrders: (orders:OrderProps[]) => {
        let event_ids:string[] = [], tournament_ids:string[] = [], match_ids:string[] = [], athlete_ids:string[] = [], team_ids:string[] = []
        orders.map(o => {
            if(o.event_type == 'team'){ event_ids.push(o.event_id) }
            if(o.event_type == 'tournament'){ tournament_ids.push(o.event_id) }
            if(o.event_type == 'match'){ match_ids.push(o.event_id) }
            if(o.side_type == 'athlete'){ athlete_ids.push(o.side_id) }
            if(o.side_type == 'team'){ team_ids.push(o.side_id) }
        })
        return { event_ids, tournament_ids, match_ids, athlete_ids, team_ids }
    },
    getContestDetails: (order?:OrderProps, events?:EventProps[], tournaments?:TournamentProps[], matches?:MatchProps[], athletes?:AthleteProps[], teams?:TeamProps[], leagues?:LeagueProps[]):{ title:string, time:string, league?:LeagueProps, athlete?:AthleteProps, team?:TeamProps } => {
        if(!order){ return { title: '', time: '' } }
        athletes = athletes ?? []
        teams = teams ?? []
        events = events ?? []
        tournaments = tournaments ?? []
        leagues = leagues ?? []
        matches = matches ?? []
        
        let athlete = order.side_type == 'athlete' ? athletes.find(a => a.athlete_id == order.side_id) : undefined
        let team = order.side_type == 'team' ? teams.find(t => t.team_id == order.side_id) : undefined;
        
        switch(order.event_type){
            case 'team': 
                let event = events.find(e => e.event_id == order.event_id);
                if(!event){ return { team, athlete, title: '', time: '' } }
                let league = leagues.find(l => l.league_id == event.league_id);
                return { team, athlete, league, title: event.event_title, time: event.status == 'scheduled' ? moment(event.scheduled_datetime).format('MM/DD @ hh:mm a') : event.time_detail ?? '' }
            case 'match':
                let match = matches.find(m => m.match_id == order.event_id);
                if(!match){ return { team, athlete, title: '', time: '' } }
                let tourney = tournaments.find(t => t.tournament_id == match.tournament_id);
                let m_league = leagues.find(l => l.league_id == tourney?.league_id)
                return { team, athlete, league: m_league, title: match.match_title, time: moment(match.scheduled_datetime).format('MM/DD @ hh:mm a') }
            case 'tournament':
                let tournament = tournaments.find(t => t.tournament_id == order.event_id);
                if(!tournament){ return { title: '', time: '' } }
                const t_league = leagues.find(l => l.league_id == tournament.league_id)
                return { team, athlete, league: t_league, title: tournament.tournament_name, time: moment(tournament.scheduled_datetime).format('MM/DD @ hh:mm a') }
            default : return { title: '', time: '' }
        }
    },
    getOddsLabel: (odds:number, decimals?:number) => {
        let new_odds = odds.toFixed()
        if(decimals){ new_odds = odds.toFixed(decimals) }
        if(odds < 0){ return `${new_odds}` }
        return `+${new_odds}`
    }
}

const SocialComponentHelpers = {
    getPostsData: async(posts:PostProps[]):Promise<{ posts:PostProps[], orders:OrderProps[], players:PublicPlayerProps[], articles:ArticleProps[] }> => {
        try {
            let player_ids:string[] = []
            let order_ids:string[] = []
            let article_ids:string[] = []
            
            //Map through the posts and add everything we need!
            posts.map(p => {
                player_ids.push(p.player_id);
                if(p.tags){ p.tags.map(t => {
                    if(t.type == 'player'){ player_ids.push(t.tag_type_id ?? '0') }
                    //Add more functionality
                }) }
                if(p.memo_articles){ p.memo_articles.map(a => article_ids.push(a)) }
                if(p.memo_orders){ p.memo_orders.map(o => order_ids.push(o)) }
            });

            order_ids = [  ...new Set(order_ids.map(id => id)) ]
            player_ids = [  ...new Set(player_ids.map(id => id)) ]
            article_ids = [  ...new Set(article_ids.map(id => id)) ]

            let players = await SocialComponentApi.getPlayersByIds(player_ids);
            let orders = await SocialComponentApi.getBulkOrders(order_ids);
            let articles = await SocialComponentApi.getBulkArticles(article_ids);
            //Lets now map back through if there are any tags and we should add the tag for them!
            posts = posts.map(p => {
                if(!p.tags){ return p }
                p.tags = p.tags.map(t => {
                    if(t.type == 'player'){
                        let player = players.find(p => p.player_id == t.tag_type_id)
                        t.data = player
                    }
                    return t
                });
                return p
            });
            return { posts, players: players, orders:orders, articles }
        } catch (e) {
            console.log(e);
            return { posts, players:[], orders:[], articles:[] }
        }
    },
    organizeImages:(images:any[], containerWidth:number, maxHeight:number, padding = 10, minWidth = 100) => {
        // Calculate aspect ratios and add to image objects
        const imagesWithRatio = images.map(img => ({
            ...img,
            aspectRatio: img.width / img.height
        }));
    
        // Sort by aspect ratio for consistency
        imagesWithRatio.sort((a, b) => a.aspectRatio - b.aspectRatio);
    
        const rows = [];
        let currentRow = [];
        //const ratioThreshold = 0.3; // Used as a preference, not a hard requirement
    
        for (const image of imagesWithRatio) {
            currentRow.push(image);
            
            const rowFit = SocialComponentHelpers.calculateRowFit(currentRow, containerWidth, maxHeight, padding, minWidth);
            
            // Only split if row doesn't fit and we have more than one image
            if (!rowFit.fits && currentRow.length > 1) {
                currentRow.pop();
                rows.push(SocialComponentHelpers.adjustRow(currentRow, containerWidth, maxHeight, padding, minWidth));
                currentRow = [image];
            }
        }
    
        if (currentRow.length > 0) {
            rows.push(SocialComponentHelpers.adjustRow(currentRow, containerWidth, maxHeight, padding, minWidth));
        }
    
        return rows;
    },
    
    // Helper function to check if row fits
    calculateRowFit: (row:any, containerWidth:number, maxHeight:number, padding:number, minWidth:number) => {
        const totalPadding = (row.length + 1) * padding;
        const availableWidth = containerWidth - totalPadding;
        
        let totalMinWidth = 0;
        row.forEach((img:any) => {
            const heightForMinWidth = minWidth / img.aspectRatio;
            const height = Math.min(maxHeight, heightForMinWidth);
            totalMinWidth += Math.max(minWidth, height * img.aspectRatio);
        });
    
        return {
            fits: totalMinWidth <= availableWidth,
            totalWidth: totalMinWidth + totalPadding
        };
    },
    
    // Helper function to adjust images in a row
    adjustRow:(row:any, containerWidth:number, maxHeight:number, padding:number, minWidth:number) => {
        const totalPadding = (row.length + 1) * padding;
        const availableWidth = containerWidth - totalPadding;
        
        let totalAspectRatio = row.reduce((sum:any, img:any) => sum + img.aspectRatio, 0);
        let rowHeight = availableWidth / totalAspectRatio;
        
        if (rowHeight > maxHeight) {
            rowHeight = maxHeight;
        }
    
        return row.map((img:any) => {
            let scaledWidth = rowHeight * img.aspectRatio;
            let scaledHeight = rowHeight;
    
            if (scaledWidth < minWidth) {
                scaledWidth = minWidth;
                scaledHeight = minWidth / img.aspectRatio;
            }
    
            return {
                ...img,
                scaledWidth: scaledWidth,
                scaledHeight: scaledHeight,
                paddingLeft: padding,
                paddingRight: padding
            };
        });
    },
    getEmptyPost: ():PostProps => {
        return {
            memo_post_id: '',
            title: '',
            body: '',
            formatted_text:'',
            tags:[],
            memo_competitions:[],
            memo_urls: [],
            memo_events: [],
            memo_hashtags:[],
            memo_images:[],
            memo_location: {},
            memo_orders: [],
            memo_players: [],
            memo_positions:[],
            memo_teams:[],
            memo_topics:[],
            memo_videos:[],
            memo_article_feeds:[],
            memo_articles:[],
            memo_podcast_episodes:[],
            memo_podcasts:[],
            memo_polls:[],
            status: 'visible',
            player_id: '',
            post_type: 'memo',
            edited: false,
            external_social_id:'',
            url_metadata:[],
            url_preview: undefined,
            my_reactions:[],
            comment_count: 0,
            reaction_details:[],
            comment_details:[],
            create_datetime:'',
            last_update_datetime:''
        }
    },
    isPostValid: (post?:PostProps):boolean => {
        if(!post){ return false }
        if(!post.title){ return false }
        if(!post.body){ return false }
        if(!post.formatted_text){ return false }
        return true
    },
    getUrlsFromString: (str:string) => {
        const regex = /https?:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,}(?:\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?/;
        let res = str.match(regex)
        if(res && res[0]){ 
            let url = res[0]
            url = url.replace(/[.,!?;]+$/, '');
            return url
        }
        return undefined
    },
    getEmptyMessage:():GroupMessageProps => {
        return {
            group_message_id: '',
            group_id: '',
            player_id: '',
            message: '',
            formatted_text: '',
            create_datetime:'',
            last_update_datetime:'',
            message_images:[],
            message_orders:[],
            message_urls:[],
            message_videos:[],
            url_metadata:[],
            status:'published',
            visibility_status:true,
            formatted_body: {
                blocks: [],
                entityMap: {
                    value: {
                        type:'',
                        mutability: '',
                        data: {}
                    }
                }
            }
        }
    },
    getEmptyComment:():PostCommentProps => {
        return {
            activity_post_id: '',
            player_id:'',
            comment_images: [],
            comment_orders:[],
            comment_urls:[],
            comment_videos:[],
            formatted_text:'',
            post_comment_id:'',
            message: '',
            formatted_body: {
                blocks: [],
                entityMap: {
                    value: {
                        type:'',
                        mutability: '',
                        data: {}
                    }
                }
            },
            status:'visible',
            post_type: 'memo',
            edited: false,
            my_reactions:[],
            reaction_details: [],
            create_datetime:'', last_update_datetime:''

        }
    },
    extractTagsFromText: (text:string, cursor?:number):TextTagProps[] => {
        let tags:TextTagProps[] = []
        let split_text = text.split(' ');
        if(split_text.length == 0){ return [] }
        let location = 0
        split_text.map(t => {
            let text_length = t.length + 1
            location += text_length
            if(t[0] == '@'){
                let tag = t.split('@')[1]
                let start = location - text_length
                let end = location - 1
                const active = cursor && cursor >= start && cursor <= end ? true :false
                tags.push({ local_id:Math.random().toString(), indicator:'@', type:'player', tag: tag ?? '', start, end, active})
            }
        })
        return tags
    },
    replaceText :(originalText:string, startIndex:number, endIndex:number, replacementText:string) => {
        const before = originalText.substring(0, startIndex);
        const after = originalText.substring(endIndex);
        return before + replacementText + after;
    },
    compareTags: (valid_tags:TextTagProps[], tags:TextTagProps[]) => {

        let final_tags:TextTagProps[] = []
        //First - lets make sure the valid tag is still valid!
        valid_tags.map(vt => {
            let exists = tags.find(t => t.tag == vt.tag && t.type == vt.type);
            if(exists){ final_tags.push({ ...exists, tag_type_id: vt.tag_type_id, data: vt.data, valid: true, local_id: (Math.random() * 100000).toFixed() }) }
        });

        //Now lets check if we have any ta


        return final_tags
    },
    addDataToMessages: async(gms:GroupMessageProps[]):Promise<{ group_messages:GroupMessageProps[], players:PublicPlayerProps[], orders:OrderProps[] }> => {
        try {
            let player_ids:string[] = []
            let order_ids:string[] = []
            let article_ids:string[] = []
            
            //Map through the posts and add everything we need!
            gms.map(p => {
                player_ids.push(p.player_id);
                if(p.tags){ p.tags.map(t => {
                    if(t.type == 'player'){ player_ids.push(t.tag_type_id ?? '0') }
                    //Add more functionality
                }) }
                if(p.message_orders){ p.message_orders.map(o => order_ids.push(o)) }
            });

            order_ids = [  ...new Set(order_ids.map(id => id)) ]
            player_ids = [  ...new Set(player_ids.map(id => id)) ]
            article_ids = [  ...new Set(article_ids.map(id => id)) ]

            let players = await SocialComponentApi.getPlayersByIds(player_ids);
            let orders = await SocialComponentApi.getBulkOrders(order_ids);

            //Lets now map back through if there are any tags and we should add the tag for them!
            gms = gms.map(p => {
                if(!p.tags){ return p }
                p.tags = p.tags.map(t => {
                    if(t.type == 'player'){
                        let player = players.find(p => p.player_id == t.tag_type_id)
                        t.data = player
                    }
                    return t
                });
                return p
            });
            return { group_messages: gms, players: players, orders:orders }
        } catch (e) {
            return { group_messages:gms, players:[], orders:[] }
        }
    },
    addTagsToMessages: async(gms:GroupMessageProps[]):Promise<GroupMessageProps[]> => {
        try {
            if(gms.length == 0){ return [] }
            let gms_with_tags = gms.filter(m => m.tags && m.tags.length > 0);
            if(gms_with_tags.length == 0){ return gms }
            let player_ids:string[] = []
            gms_with_tags.map(gm => {
                if(!gm.tags || gm.tags.length == 0){ return }
                let gm_player_ids = gm.tags.filter(t => t.type == 'player' && t.tag_type_id).map(t => t.tag_type_id ?? '');
                player_ids = player_ids.concat(gm_player_ids);
            });
            let players = await SocialComponentApi.getPlayersByIds(player_ids);

            gms = gms.map(gm => {
                if(!gm.tags || gm.tags.length == 0){ return gm }
                gm.tags = gm.tags.map(tag => {
                    switch(tag.type){
                        case 'player':
                            let player = players.find(p => p.player_id == tag.tag_type_id);
                            if(!player){ return tag }
                            return { ...tag, data: player }
                        default: return tag
                    }
                })
                return gm
            })
            return gms
        } catch (e) {
            console.log('unable');
            return gms
        }
    },
}

const SocialPodcastHelpers = {
    getPodcastImage: (podcast:PodcastProps):string => {
        let image_source = podcast.image_override?.url
        if(!image_source){ image_source = podcast.image?.url }
        if(image_source && image_source !== ''){ return image_source }
        return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1728494579/default_pod_nji5sk.webp'
    },
    getEpisodeImage: (podcast_episode?:PodcastEpisodesProps):string => {
        if(!podcast_episode){ return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1728494579/default_pod_nji5sk.webp' }
        let image_source = podcast_episode.image_override?.url
        if(!image_source){ image_source = podcast_episode.image?.url }
        if(image_source && image_source != ''){ return image_source }
        return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1728494579/default_pod_nji5sk.webp'
    },
    formatTime: (time:number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time - minutes * 60);
        const final_time = SocialPodcastHelpers.str_pad_left(minutes, '0', 2) + ':' + SocialPodcastHelpers.str_pad_left(seconds, '0', 2);
        return final_time
    },
    str_pad_left: (string:number, pad:string, length:number) => {
        return (new Array(length + 1).join(pad) + string).slice(-length);
    }
}